import * as React from "react";
import { forwardRef } from "react";
const SvgIcExclamation = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 7 21", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M.9 0h5.2l-0.6 13.8h-4l-0.6-13.8Zm0 18c0-1.4 1.2-2.3 2.6-2.3c1.4 0 2.5 .9 2.5 2.3c0 1.4-1.1 2.3-2.5 2.3c-1.4 0-2.6-0.9-2.6-2.3Z", fill: "#fff" }));
const ForwardRef = forwardRef(SvgIcExclamation);
export { ForwardRef as ReactComponent };
